import { useEffect, useState } from "react";
import { Users, Gift, ExternalLink, Copy, Check } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AffiliateDashboardSection = ({ user }) => {
  const [referralData, setReferralData] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (user?.user_id) {
      fetch(`${BACKEND_URL}/api/referral/stats?user_id=${user.user_id}`)
        .then(r => r.json())
        .then(setReferralData)
        .catch(() => {});
    }
  }, [user?.user_id]);

  const referralLink = referralData?.referral_code ? `${window.location.origin}?ref=${referralData.referral_code}` : "";
  const copyLink = () => { navigator.clipboard.writeText(referralLink); setCopied(true); setTimeout(() => setCopied(false), 2000); };

  if (!referralData) return <div className="text-center text-white/40 py-8">Loading...</div>;

  return (
    <div className="space-y-6">
      <div className="bg-white/5 border border-white/10 rounded-2xl p-6">
        <div className="flex items-center gap-3 mb-4">
          <Gift className="w-6 h-6 text-purple-400" />
          <h3 className="text-lg font-bold text-white">Your Referral Link</h3>
        </div>
        <p className="text-white/50 text-sm mb-4">Share this link. For every creator who signs up, you earn <strong className="text-purple-400">1 free month</strong>.</p>
        <div className="flex gap-2 mb-2">
          <div className="flex-1 bg-black/30 border border-white/10 rounded-xl px-4 py-3 text-purple-400 font-mono text-sm truncate">
            {referralLink}
          </div>
          <button onClick={copyLink} className="bg-purple-500/20 hover:bg-purple-500/30 text-purple-400 px-5 py-3 rounded-xl transition flex items-center gap-2 text-sm font-medium flex-shrink-0" data-testid="affiliate-tab-copy">
            {copied ? <><Check className="w-4 h-4" /> Copied!</> : <><Copy className="w-4 h-4" /> Copy</>}
          </button>
        </div>
        <p className="text-white/30 text-xs">Code: <span className="font-mono text-white/50">{referralData.referral_code}</span></p>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="bg-white/5 border border-white/10 rounded-2xl p-6 text-center">
          <Users className="w-8 h-8 text-purple-400 mx-auto mb-2" />
          <p className="text-3xl font-bold text-white">{referralData.referral_count}</p>
          <p className="text-white/40 text-sm">Creators Referred</p>
        </div>
        <div className="bg-white/5 border border-white/10 rounded-2xl p-6 text-center">
          <Gift className="w-8 h-8 text-green-400 mx-auto mb-2" />
          <p className="text-3xl font-bold text-green-400">{referralData.reward_months}</p>
          <p className="text-white/40 text-sm">Free Months Earned</p>
        </div>
      </div>

      {referralData.referred_users?.length > 0 && (
        <div className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden">
          <div className="p-4 border-b border-white/10"><h3 className="font-bold">Your Referrals</h3></div>
          <div className="divide-y divide-white/5">
            {referralData.referred_users.map((u, i) => (
              <div key={i} className="p-4 flex items-center justify-between">
                <div><p className="text-white font-medium text-sm">{u.name}</p><p className="text-white/40 text-xs">{u.email}</p></div>
                <p className="text-white/40 text-xs capitalize">{u.plan}</p>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="text-center">
        <a href="/affiliate" className="text-purple-400 hover:text-purple-300 text-sm flex items-center gap-1 justify-center transition">
          <ExternalLink className="w-3.5 h-3.5" /> View Full Affiliate Page
        </a>
      </div>
    </div>
  );
};

export default AffiliateDashboardSection;
